import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    addRecurringCharges: {
        method: 'POST',
        url: `${BASE_PATH_API}/recurringcharges`
    },
    getRecurringCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringcharges/:propertyType/list`
    },
    updateBulkRecurringCharges: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringcharges/:propertyType/update`
    },
    deleteBulkRecurringCharges: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/recurringcharges/:propertyType/delete`
    },
    getRecurringCharge: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringcharges/:id`
    },
    updateRecurringCharge: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringcharges/:id`
    },
    deleteRecurringTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/recurringCharges/:id`
    }
};

export function RecurringChargesApi() {
    return createActions(actions);
}
